<template>
  <section id="clients" class="rt-section clients">
    <div class="rt-inner">
      <div class="rt-section-head">
        <span class="rt-eyebrow clients__eyebrow">CLIENTS</span>
        <h2 class="rt-section-title">主要取引先</h2>
      </div>
      <div class="clients__grid">
        <span v-for="name in clients" :key="name" class="clients__item">{{ name }}</span>
      </div>
      <p class="clients__note">（五十音・アルファベット順／一部・敬称略）</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeClients',
  setup () {
    // 法人格を無視した社名の昇順（英字→カナ→漢字）
    const clients = [
      '株式会社ABCフロンティア',
      '合同会社DMM.com',
      '株式会社EMP',
      '株式会社JRCアカウンティング',
      '株式会社LDH music&publishing',
      '株式会社Ligareaz Entertainment',
      '株式会社NHK出版',
      '株式会社PCI MUSIC',
      '株式会社ROOFTOP MUSIC',
      '株式会社SDR',
      '株式会社STPR',
      'アソビミュージック株式会社',
      '株式会社アップフロント音楽出版',
      '株式会社インクストゥエンター',
      '株式会社ウルトラ・ヴァイヴ',
      '株式会社エフ・エー・アール・エム',
      '株式会社オフィスオーガスタ',
      '株式会社スタジオジブリ',
      '株式会社ティーズ音楽出版',
      '株式会社テイチクエンタテインメント',
      '株式会社テレビ朝日ミュージック',
      '株式会社ネルケプランニング',
      'ビクターミュージックアーツ株式会社',
      '株式会社ポリスター',
      '株式会社ワーナーミュージック・ジャパン',
      '株式会社電通ミュージック・アンド・エンタテインメント',
      '渡辺音楽出版株式会社'
    ]
    return { clients }
  }
}
</script>

<style scoped>
.clients {
  background: var(--surface);
}

.clients__eyebrow {
  color: var(--brand-blue);
  background: var(--blue-bg);
}

.clients__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.clients__item {
  font-size: 12.5px;
  color: var(--ink-soft);
  background: var(--surface-soft);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clients__note {
  font-size: 11px;
  color: var(--ink-mute);
  text-align: center;
  margin-top: 14px;
}

@media (max-width: 768px) {
  .clients__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
